import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../services/supabaseClient';

export function calculateAvailableBalance(transactions) {
  const balance = transactions.reduce(
    (total, transaction) => total + Number(transaction.credit || 0) - Number(transaction.debit || 0),
    0
  );
  return Math.round(balance * 100) / 100;
}

function localDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function useAvailableBalance(userId) {
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    if (!userId) {
      setBalance(0);
      setError('');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError('');
    const transactions = [];
    const pageSize = 1000;
    let offset = 0;

    while (true) {
      const { data, error: queryError } = await supabase
        .from('transactions')
        .select('credit, debit')
        .eq('user_id', userId)
        .lte('date', localDateKey(new Date()))
        .order('date', { ascending: true })
        .order('id', { ascending: true })
        .range(offset, offset + pageSize - 1);

      if (queryError) {
        setError(queryError.message);
        setLoading(false);
        return;
      }

      transactions.push(...(data || []));
      if (!data || data.length < pageSize) break;
      offset += pageSize;
    }

    setBalance(calculateAvailableBalance(transactions));
    setLoading(false);
  }, [userId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { balance, loading, error, refresh };
}
